import {
    ALGOLIA_APP_ID,
    ALGOLIA_SEARCH_KEY,
    ALGOLIA_INDEX_BY_TIMESTAMP
} from "../search/constants";

import algoliasearch from "algoliasearch/lite";
import { capitalizeFirstLetter } from "../../utils";

const feedOptions = {
    main: {
        facets: ['categories_slugs', 'is_hidden', 'type', 'has_password'],
        facetFilters: [
            `has_password:false`,
            'is_hidden:false',
            'type:-Employee Bio',
            'type:-Page',
            'type:-Newsletter',
        ]
    },
    watch: {
        facets: ['categories_slugs', 'is_hidden', 'type', 'is_watch', 'has_password'],
        facetFilters: [
            `has_password:false`,
            'is_hidden:false',
            'is_watch:true',
            'type:-Employee Bio',
            'type:-Page',
            'type:-Newsletter',
        ]
    },
    podcasts: {
        facets: ['categories_slugs', 'is_hidden', 'type', 'is_watch', 'has_password'],
        facetFilters: [
            `has_password:false`,
            'is_hidden:false',
            'is_watch:false',
            'type:Podcast',
            'type:-Newsletter',
        ]
    },
    articles: {
        facets: ['categories_slugs', 'is_hidden', 'type', 'is_watch', 'has_password'],
        facetFilters: [
            `has_password:false`,
            'is_hidden:false',
            'is_watch:false',
            ['type:Article','type:Company Announcement']
        ]
    }
}

const getFeedOptions = (feedType, categories, hits, page) => {
    const options = feedOptions[feedType] || feedOptions.main;
    options.hitsPerPage = hits;
    options.page = page;
    let categories_slugs = categories.map(category => `categories_slugs:${category}`);
    options.facetFilters.push(categories_slugs);
    return options;
}

class MixedFeedCategoryList {
    constructor(el, algolia) {
        this.el = el;
        this.algolia = algolia;
        this.currentPage = 1;
        this.feedType = this.el.dataset.feedType;
        this.categories = this.algolia.categories;
        this.postsHit = this.algolia.postsHit;
        this.index = this.algolia.index;
        this.hiddenPosts = Array.from(this.el.querySelectorAll('.hidden'));
        this.useAPI = this.el.dataset.feedApi === 'true';
        this.init();
    }

    init() {
        this.tabButton = document.querySelector(`[data-tab="${ this.feedType }"]`);
        this.feedEl = this.el.querySelector(".posts-list");
        this.loadMoreBtn = this.el.querySelector(".load-more-posts-category");
        if(this.hiddenPosts.length > 0) {
            this.loadMoreBtn.removeAttribute('style');
        }

        this.loadMoreButton();
    }

    loadPostsFromPage() {
        let toShow = this.hiddenPosts.splice(0, this.postsHit);
        toShow.forEach(post => post.classList.remove('hidden'));
        if (this.hiddenPosts.length === 0 && ! this.useAPI) {
            this.loadMoreBtn.style.display = 'none';
        }
        this.currentPage ++;
    }

    loadPostsFromAlgolia() {
        const options = getFeedOptions(this.feedType, this.categories, this.postsHit, this.currentPage);

        this.index.search('', options).then(({hits, nbPages}) => {
            if (hits.length === 0) {
                this.loadMoreBtn.style.display = 'none';
            } else {
                hits.forEach(hit => {
                    this.feedEl.innerHTML += this.renderPost(hit);
                });
                this.currentPage += 1;
                this.loadMoreBtn.style.display = this.currentPage < nbPages ? 'inline-flex' : 'none';
            }
        }).catch(err => {
            console.error(err);
        });
    }

    renderTags(tags) {
        return tags.map(tag => `<span class="tag is-${tag}">${capitalizeFirstLetter(tag)}</span>`).join('');
    }

    renderIcon(postType) {
        let icon = '';
        switch (postType) {
            case 'Podcast':
                icon = '<i class="icon-headphone"></i>';
                break;
            case 'Company Announcement':
                icon = '<i class="icon-speaker"></i>';
                break;
        }

        return icon;
    }

    renderPost(item) {
        const title = item.title_custom || item.title;
        return `
            <li>
                <div class="heading">
                    <h6>
                        <a href="${item.url}" target="_blank" rel="noopener noreferrer"><span>${title}</span></a>${item.tags ? this.renderTags(item.tags) : ''}
                    </h6>
                    <span class="author">${this.renderIcon(item.type)}${item.author}</span>
                </div>
                <p>${item.desc}</p>
            </li>
        `;
    }

    loadMoreButton() {
        this.loadMoreBtn.onclick = (e) => {
            e.preventDefault();
            if (this.hiddenPosts.length > 0) {
                this.loadPostsFromPage();
            } else {
                this.loadPostsFromAlgolia();
            }
        };
    }
}

export default class MixedFeedCategory {

    static create(el) {
        new MixedFeedCategory(el);
    }

    constructor(el) {
        this.el = el;
        this.clientId = ALGOLIA_APP_ID;
        this.apiKey = ALGOLIA_SEARCH_KEY;
        this.indexName = window.search_index_timestamp || ALGOLIA_INDEX_BY_TIMESTAMP;
        this.init();
    }

    init() {
        this.category = this.el.dataset.feedComponentCategoryMixed;
        console.log(this.category);
        this.categories = this.category.split(',');
        this.postsHit = parseInt(this.el.dataset.feedCount, 10);

        this.client = algoliasearch(this.clientId, this.apiKey);
        this.index = this.client.initIndex(this.indexName);

        this.listsEl = this.el.querySelectorAll('[data-feed-type]');
        this.lists = [];

        this.listsEl.forEach(list => {
            this.lists.push(new MixedFeedCategoryList(list, this));
        })
    }
}
